import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BasicInformation from './BasicInformation';
import { profileDto } from '../../../api/Dtos/profileDto';
import ServicesOffered from './ServicesOffered';
import LeaderShipTeam from './LeaderShipTeam';
import CenterAndLocation from './CenterAndLocation';
import { getService } from '../../../servce/ApisService';
import { useForm } from 'react-hook-form';
import { API_ENDPOINTS } from '../../../api';
import { useLoader } from '../../../Loader/LoaderContext';
import { mtCountryDto, mtCurrencyDto } from '../../../api/interfaces/addUser';
import { userInfo } from 'os';

function HospitalPreview() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
      const { setLoading } = useLoader();
      const [phoneCode, setPhonecode] = useState({ isoCode: "", code: "" });
  const [selectedCountry, setSelectedCountry] = useState("");
    const {
        register,
        handleSubmit,
        control,
        watch,
        setValue,
        reset,
        formState: { errors },
      } = useForm<profileDto>({
        defaultValues: {
          name: '',
          email: '',
          phoneNo: '',
          phoneisoCode: '',
          hospitalInfo: '',
          specialization: '',
          size: '',
          street: '',
          apartment: '',
          state: '',
          postalCode: '',
          mtCountryDto: { id: 0, name: '' },
          city: '',
          imageDto: {},
          serviceOfferedDtos: [{ type: '', cost: '', mtCurrencyDto: { id: 0, name: '' } }],
          leaderShipTeamDtos: [{ id: 0, name: '', gender: '', designation: '', bio: '', address: '', fileDto: {} }],
          hospitalCenterReqDtos: [{ id: 0, branchAddress: '', specialization: '', centerSize: '', imageDto: {}, type: '', name: '' }],
          profileStatus: '',
        },
        mode: 'onChange',
      });
      const [events, setEvents] = useState<any[]>([]);
      const [events1, setEvents1] = useState<any[]>([]);
      const watchedServices = watch('serviceOfferedDtos');
     const [searchParams] = useSearchParams();
      const leadId = searchParams.get("leadId");
      const vendorId =searchParams.get("vendorId");
      const names =searchParams.get("name");
    const [data,setData]=useState<profileDto | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    const users = () => {
        if (path === "/portals/leads/viewUser/previewHospital") {
            navigate("/portals/leads/viewUser"); // Navigate to viewUser for Leads
        }else if(path === "/portals/proposals/viewProposal/previewHospital"){
          navigate("/portals/proposals/viewProposal");
        }else if(path === "/portals/vendors/activeVendor/previewHospital"){
          navigate("/portals/vendors/activeVendor");
        }else if(path === "/portals/vendors/inActiveVendor/previewHospital"){
          navigate("/portals/vendors/inActiveVendor");
        }else if(path === "/portals/bookings/viewBooking/previewHospital"){
          if(names == 'booked'){
            navigate("/portals/bookings/viewBooking");
          }else {
            navigate("/portals/bookings/confirmedBooking");
          }
        }else if(path === "/portals/bookings/confirmedBooking/previewHospital"){
         
            navigate("/portals/bookings/confirmedBooking");
        
        }
        else if( path === "/portals/enquiries/contactUs/previewHospital"){
          navigate("/portals/enquiries/contactUs")
        }else if( path === "/portals/enquiries/posts/previewHospital"){
          navigate("/portals/enquiries/posts")
        }else if( path === "/portals/enquiries/events/previewHospital"){
          navigate("/portals/enquiries/events")
        }else if(path ==='/portals/enquiries/vendors/previewHospital'){
          navigate('/portals/enquiries/vendors')
        }
        
    };
    useEffect(() => {
        const initializeData = async () => {
          setLoading(true);
          try {
            await mtCountryDtoData();
            await fetchDetails();
            // await fetchMtCurrencyData();
          } catch (error) {
            console.error("Error during initialization:", error);
          } finally {
            setLoading(false);
          }
        };
      
        initializeData();
      }, []);
      const mtCountryDtoData = async () => {
        setLoading(true);
        try {
          const response = await getService(API_ENDPOINTS.countryData);
          console.log(response.data);
          setMtCountry(response.data);
          return response.data;
        } catch (error) {
          console.error("Error fetching vehicle data:", error);
        } finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      };
    
    const fetchDetails = async () => {
        try {
          setLoading(true);
          let url:any;
          if(path ==='/portals/enquiries/contactUs/previewCompany' || path === '/portals/enquiries/posts/previewHospital' || vendorId){
                                   url = API_ENDPOINTS.getProfile+"?vendorId="+vendorId
                                  }else{
                                    url =API_ENDPOINTS.getProfile+"?leadId="+leadId
                                  }
          const response = await getService(url); // Fetch post details using 'id'
    setData(response.data);
    const res =response.data;
    setEvents(response.data.leaderShipTeamDtos);
    setEvents1(response.data.hospitalCenterReqDtos)
    const countryData = await mtCountryDtoData();
    setSelectedCountry(response.data?.mtCountryDto?.id);
    const selectedIsoCode = response.data?.mtCountryDto?.id;
     const selectedCountry = countryData.find(
        (country: any) => country.id === selectedIsoCode
      );
      if (selectedCountry) {
        setPhonecode({
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        });
        setValue("phoneisoCode", selectedIsoCode);}
        else{
          const selectedCountry = countryData.find(
            (country: any) => country.id == "1"
          );
          setPhonecode({
            isoCode: selectedCountry.isoCode,
            code: selectedCountry.code,
          });
          setValue("phoneisoCode", selectedIsoCode);
         }
    reset({
      ...response.data, // Resetting other data from the response
    })
          setTimeout(() => {
            setLoading(false); // Stop loader after 500ms
            // setIsLoading(false); // Stop local loading
          }, 500);
        } catch (error) {
          console.error("Error fetching post details:", error);
          setTimeout(() => {
            setLoading(false); // Stop loader in case of error
            // setIsLoading(false);
          }, 500);
        }finally{
          setTimeout(() => {
            setLoading(false); // Stop loader in case of error
            // setIsLoading(false);
          }, 500);
        }
      };
    const onEdit=()=>{
        if (path === "/portals/leads/viewUser/previewHospital") {
            navigate("/portals/leads/viewUser/editHospitals?leadId="+leadId); // Navigate to viewUser for Leads
        } else if(path === "/portals/proposals/viewProposal/previewHospital"){
          navigate("/portals/proposals/viewProposal/editHospitals?leadId="+leadId);
        }else if(path === "/portals/vendors/activeVendor/previewHospital"){
          navigate("/portals/vendors/activeVendor/editHospitals?leadId="+leadId);
        }else if(path === "/portals/vendors/inActiveVendor/previewHospital"){
          navigate("/portals/vendors/inActiveVendor/editHospitals?leadId="+leadId);
        }else if(path === "/portals/bookings/viewBooking/previewHospital"){
          navigate("/portals/bookings/viewBooking/editHospitals?leadId="+leadId+"&name="+names);
        }
        else if(path === "/portals/bookings/confirmedBooking/previewHospital"){
          navigate("/portals/bookings/confirmedBooking/editHospitals?leadId="+leadId+"&name="+names);
        }
    }
    return (
        <div className="h-full py-2 w-full">
            <div className="flex items-center cursor-pointer mb-4">
                <h2
                    className="mr-2 text-gray-700 font-semibold text-sm"
                    onClick={users}
                >
                   {path === "/portals/proposals/viewProposal/previewHospital" ? 'Proposal' : path === "/portals/vendors/activeVendor/previewHospital" ||  path === "/portals/vendors/inActiveVendor/previewHospital" ? 'Vendors' : 
                   path === "/portals/bookings/viewBooking/previewHospital" || path ==='/portals/bookings/confirmedBooking/previewHospital' ? ' Booked' :
                   ( path === "/portals/enquiries/contactUs/previewHospital" ||  path === "/portals/enquiries/posts/previewHospital"  || path === "/portals/enquiries/events/previewHospital" || path ==='/portals/enquiries/vendors/previewHospital' ) ? 'Enquiries' : 
                   'Leads'} 
                </h2>{" "}

                <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
                <span className="text-gray-400 font-semibold text-sm">
                    
                    {path === "/portals/proposals/viewProposal/previewHospital" ? 'View Proposals' : path === "/portals/vendors/activeVendor/previewHospital" ||  path === "/portals/vendors/inActiveVendor/previewHospital" ? 'View Vendors' : 
                    path === "/portals/bookings/viewBooking/previewHospital" ? 'View Booked' :
                    path ==='/portals/bookings/confirmedBooking/previewHospital' ? 'View Confirmed' :
                    path === "/portals/enquiries/contactUs/previewHospital" ? 'Contact Us' :
                    path === "/portals/enquiries/posts/previewHospital"  ? 'Posts' :
                    path === "/portals/enquiries/events/previewHospital"  ? 'Events' :
                    path ==='/portals/enquiries/vendors/previewHospital' ? 'Vendors' :
                    'View Leads'} 
                </span>
            </div>
            <div className='flex justify-between w-full'>
                <div className='flex items-center mb-2'>
                    <img src='/images/back.svg' className='mr-2 cursor-pointer' onClick={users} />
                    <h1 className="text-2xl fonxt-bold text-[#2D2E2F] mr-3"> {path === "/portals/proposals/viewProposal/previewHospital" ? 'View Proposals' : path === "/portals/vendors/activeVendor/previewHospital" ||  path === "/portals/vendors/inActiveVendor/previewHospital" ? 'View Vendors': 
                    path === "/portals/bookings/viewBooking/previewHospital" ? 'View Booked' : 
                    path ==='/portals/bookings/confirmedBooking/previewHospital' ?'View Confirmed' :
                    ( path === "/portals/enquiries/contactUs/previewHospital" ||  path === "/portals/enquiries/posts/previewHospital"  || path === "/portals/enquiries/events/previewHospital" ) ? 'View Hospital' :
                    path ==='/portals/enquiries/vendors/previewHospital' ? 'View Hospital' :
                    'View Leads'} </h1>
                </div>
                {
                ( (userInfo?.roles !=='PUBLISHER' &&  userInfo?.roles !=='CONTENT_ADMIN' && userInfo?.roles !=='CHIEF_EDITOR') &&  path !=='/portals/enquiries/contactUs/previewHospital' && path !=='/portals/enquiries/posts/previewHospital') && path !=='/portals/enquiries/vendors/previewHospital' &&
                <div className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4 cursor-pointer' onClick={onEdit}><span className='mr-2'><img src='/images/Edit_Pencil.svg' /></span>Edit</div>}
            </div>
            <div>
                <BasicInformation submittedData={data}/>
            </div>
            <div>
                <ServicesOffered submittedData={data}/>
            </div>
            <div>
                <LeaderShipTeam submittedData={data}/>
            </div>
            <CenterAndLocation submittedData={data}/>

        </div>
    )
}

export default HospitalPreview
